import { getEnvironmentIndicator, type EnvironmentIndicator } from '@/lib/environment-indicator';

type BackofficeBrandMarkProps = {
  logoClassName?: string;
};

export function BackofficeBrandMark({
  logoClassName = 'h-6 w-auto md:h-7',
}: BackofficeBrandMarkProps) {
  const environmentIndicator = getEnvironmentIndicator();

  return (
    <>
      <span className="relative inline-flex items-center">
        <img src="/logo.svg" alt="Nava" className={logoClassName} />
        <EnvironmentBadge indicator={environmentIndicator} />
      </span>
      <span className="mt-0.5 text-[9px] font-semibold uppercase tracking-[0.28em] text-backoffice-500">
        Backoffice
      </span>
    </>
  );
}

function EnvironmentBadge({ indicator }: { indicator: EnvironmentIndicator | null }) {
  if (!indicator) return null;

  return (
    <span
      className="pointer-events-none absolute -bottom-2 right-0 rounded px-1 py-0.5 text-[8px] font-bold leading-none text-white shadow-sm"
      style={{ backgroundColor: indicator.badgeColor }}
    >
      {indicator.label}
    </span>
  );
}
